import { render, staticRenderFns } from "./fishingLayout.vue?vue&type=template&id=33fd511b&"
import script from "./fishingLayout.vue?vue&type=script&lang=js&"
export * from "./fishingLayout.vue?vue&type=script&lang=js&"
import style0 from "./fishingLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports